module.exports = __webpack_public_path__ + "img/fiel-Logo.bcfbeacb.png";